var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 57,
    viewBox: "0 0 24 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C10 0.89543 10.8954 0 12 0C13.1046 0 14 0.895431 14 2V44.5506C14 45.5737 15.3545 45.9367 15.866 45.0506L19.8998 38.064C20.4525 37.1067 21.6766 36.7787 22.6339 37.3314C23.5913 37.8841 23.9193 39.1082 23.3666 40.0656L14.3705 55.6472C14.149 56.0309 13.8196 56.3135 13.4427 56.4788C13.3304 56.5282 13.2225 56.5878 13.1209 56.6566C12.8012 56.8734 12.4154 57 12 57C11.623 57 11.2703 56.8957 10.9693 56.7143C10.889 56.6659 10.8053 56.6231 10.719 56.5864C10.3352 56.423 9.99921 56.1382 9.77456 55.7491L0.770517 40.1536C0.21979 39.1998 0.546617 37.98 1.5005 37.4293C2.45439 36.8786 3.67412 37.2054 4.22485 38.1593L8.13397 44.9301C8.64552 45.8161 10 45.4532 10 44.4301V2Z",
    fill: "#101010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c63203a3cc4073ad4deadd6e1751c1f3.svg";
export { ForwardRef as ReactComponent };